import useSubscriptionPaymentSource from "features/payment-methods/datahooks/useSubscriptionPaymentSource";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import useCampaigns from "common/datahooks/useCampaigns";

export default function useOnboardingProgress() {
  const {
    accounts_count: accountsCount,
    subscription,
    member_count: membersCount,
  } = useSelectedWorkspaceContext();

  const { campaigns, isLoadingCampaigns } = useCampaigns();
  const { subscriptionPaymentSource, isLoadingSubscriptionPaymentSource } =
    useSubscriptionPaymentSource(subscription?.id, false);

  const hasAccounts = accountsCount > 0;
  const hasCampaigns = campaigns?.length > 0;
  const hasTeamMembers = membersCount > 1; // There will always be at at least 1 member in the workspace ("owner")
  const hasPaymentSource = !!subscriptionPaymentSource;

  // Derived state
  const steps = [hasAccounts, hasCampaigns, hasTeamMembers, hasPaymentSource];
  const completedStepsCount = steps.filter(Boolean).length;
  const isCompleted = completedStepsCount === steps.length;
  const isLoadingProgress =
    isLoadingCampaigns || isLoadingSubscriptionPaymentSource;

  return {
    isCompleted,
    completedStepsCount,
    hasAccounts,
    hasCampaigns,
    hasTeamMembers,
    hasPaymentSource,
    // Loading state
    isLoadingProgress,
    isLoadingCampaigns,
    isLoadingSubscriptionPaymentSource,
  };
}
